import { Divider } from "primereact/divider";
import PageTitle from "../common/PageTitle";
import TabHeader from "../common/TabHeader";
import CardGrid from "./common/CardGrid";

const HOME_CARDS = [
    { title: "Top banner", detail: "First screen: heading, photo, and buttons", icon: "pi-image", path: "/manage-website/home/hero" },
    { title: "Number cards", detail: "The row of big numbers under the banner", icon: "pi-chart-bar", path: "/manage-website/home/stats" },
    { title: "About story", detail: "Story text, photo, and highlight rows", icon: "pi-book", path: "/manage-website/home/about" },
    { title: "Founder", detail: "Founder photo, name, and message", icon: "pi-user", path: "/manage-website/home/founder" },
    { title: "Facilities heading", detail: "Words above the facility cards on the home page", icon: "pi-th-large", path: "/manage-website/home/facilities" },
    { title: "Courses heading", detail: "Words above the course cards. Course records stay under Courses", icon: "pi-bookmark", path: "/manage-website/home/courses" },
    { title: "App block", detail: "App heading, phone photo, and checklist", icon: "pi-mobile", path: "/manage-website/home/app" },
    { title: "Mission and vision", detail: "The two cards under the app block", icon: "pi-flag", path: "/manage-website/home/mission" },
    { title: "Latest notifications", detail: "Home shows the 3 newest notices. Edit the notices here", icon: "pi-bell", path: "/manage-website/pages/notifications" },
    { title: "Branches", detail: "The same branch cards on the home page, Contact Us, About, and the footer", icon: "pi-building", path: "/manage-website/pages/branches" },
    { title: "Testimonials", detail: "The review slider. Edit the heading and each review here", icon: "pi-comments", path: "/manage-website/pages/testimonials" },
    { title: "Achievements", detail: "Hall of fame cards", icon: "pi-star", path: "/manage-website/home/achievements" },
    { title: "Gallery preview", detail: "Scrolling photos. Use 720 ? 450 px images", icon: "pi-images", path: "/manage-website/home/gallery" },
    { title: "Brochure cards", detail: "Download cards on the home page", icon: "pi-file-pdf", path: "/manage-website/home/brochures" },
    { title: "Free app content", detail: "The free-content cards near the bottom", icon: "pi-folder-open", path: "/manage-website/home/free-content" },
    { title: "Follow us", detail: "Social heading and the social buttons", icon: "pi-share-alt", path: "/manage-website/home/contact" },
];

const ABOUT_CARDS = [
    { title: "About page text", detail: "Headings, story, journey, and the other About Us blocks", icon: "pi-info-circle", path: "/manage-website/about/text" },
];

const SITE_CARDS = [
    { title: "Site name and logo", detail: "Name, tagline, logo, phone, WhatsApp, and email used on every page", icon: "pi-cog", path: "/manage-website/site-settings" },
    { title: "Search titles", detail: "Optional. Replace the built-in Google title for one page", icon: "pi-search", path: "/manage-website/seo" },
    { title: "Top bar", detail: "Logo, name, phone, and the app button in the header", icon: "pi-bars", path: "/manage-website/header" },
    { title: "Menu links", detail: "Top menu, footer quick links, and the legal line. One page can appear in more than one place", icon: "pi-link", path: "/manage-website/links" },
    { title: "Footer text", detail: "Short description and the copyright line", icon: "pi-align-justify", path: "/manage-website/footer" },
    { title: "Phone bar", detail: "WhatsApp, Call, Courses, and App buttons fixed to the bottom of a phone", icon: "pi-mobile", path: "/manage-website/mobile-bar" },
];

const FACILITIES_CARDS = [
    { title: "Page text", detail: "Headings and introduction on the Facilities page", icon: "pi-file-edit", path: "/manage-website/facilities-page" },
    { title: "Facility cards", detail: "Each facility. Home shows the first 8 of these", icon: "pi-th-large", path: "/manage-website/facilities" },
];

const NOTIFICATION_CARDS = [
    { title: "Page text", detail: "Heading and introduction at the top of the Notifications page", icon: "pi-file-edit", path: "/manage-website/notifications-page" },
    { title: "Notices", detail: "Open a notice, then add its photos and files", icon: "pi-bell", path: "/manage-website/notifications" },
];

const TESTIMONIAL_CARDS = [
    { title: "Page text", detail: "Heading and introduction above the review slider", icon: "pi-file-edit", path: "/manage-website/testimonials-page" },
    { title: "Reviews", detail: "Each review card in the slider", icon: "pi-comments", path: "/manage-website/testimonials" },
];

const GALLERY_CARDS = [
    { title: "Page text", detail: "Heading and introduction at the top of the Gallery page", icon: "pi-file-edit", path: "/manage-website/gallery-page" },
    { title: "Folders", detail: "Open a folder, then an event, then its photos and videos", icon: "pi-folder", path: "/manage-website/gallery-categories" },
];

const BROCHURE_CARDS = [
    { title: "Page text", detail: "Heading and introduction at the top of the e-Brochures page", icon: "pi-file-edit", path: "/manage-website/brochures-page" },
    { title: "Course folders", detail: "Open a course, then add its brochure files", icon: "pi-folder", path: "/manage-website/brochures" },
];

const CONTACT_CARDS = [
    { title: "Page text", detail: "Heading and introduction at the top of the Contact Us page", icon: "pi-file-edit", path: "/manage-website/contact" },
    { title: "Branch cards", detail: "Each branch, with its address, phone, and map", icon: "pi-building", path: "/manage-website/branches" },
    { title: "Phone, WhatsApp, and email", detail: "The three Institute Contact cards. These details are used across the site", icon: "pi-phone", path: "/manage-website/site-settings" },
    { title: "Social buttons", detail: "Instagram, YouTube, and the other follow buttons", icon: "pi-share-alt", path: "/manage-website/social-links" },
];

const BRANCH_CARDS = [
    { title: "Branch cards", detail: "Name, address, phone, and map for each branch", icon: "pi-building", path: "/manage-website/branches" },
];

const COURSE_CARDS = [
    { title: "Courses", detail: "Name, photo, fees, and details used on every page", icon: "pi-book", path: "/manage-website/courses" },
    { title: "Course points", detail: "Short lines on a course card. One point can be added to several courses", icon: "pi-list", path: "/manage-website/course-features" },
    { title: "Courses page text", detail: "Headings that appear only on the Courses page", icon: "pi-file-edit", path: "/manage-website/courses-page" },
];

export const WEBSITE_CARDS = [
    { title: "Home page", detail: "Every block on the home page, from top to bottom", icon: "pi-home", path: "/manage-website/home" },
    { title: "About Us page", detail: "Text and photos for the About Us page", icon: "pi-info-circle", path: "/manage-website/about" },
    { title: "Facilities page", detail: "Facility cards and the facilities page text", icon: "pi-th-large", path: "/manage-website/pages/facilities" },
    { title: "Notifications page", detail: "Notices, photos, and attached files", icon: "pi-bell", path: "/manage-website/pages/notifications" },
    { title: "Testimonials", detail: "Heading and review cards in the home page slider", icon: "pi-comments", path: "/manage-website/pages/testimonials" },
    { title: "Gallery page", detail: "Folders, albums, and photos", icon: "pi-images", path: "/manage-website/pages/gallery" },
    { title: "e-Brochures page", detail: "Brochure page text and the PDF files", icon: "pi-file-pdf", path: "/manage-website/pages/brochures" },
    { title: "Contact Us page", detail: "Heading, branch cards, phone, and social buttons", icon: "pi-phone", path: "/manage-website/pages/contact" },
    { title: "Courses", detail: "Shared course list for the whole website", icon: "pi-book", path: "/manage-website/pages/courses" },
    { title: "Branches", detail: "Branch cards used on the home page, Contact Us, About, and the footer", icon: "pi-building", path: "/manage-website/pages/branches" },
    { title: "Website Inquiries", detail: "Leads submitted from the public website inquiry form", icon: "pi-inbox", path: "/manage-website/inquiries" },
    { title: "Site setup", detail: "Name, logo, search titles, top bar, menu, footer, and the phone bar", icon: "pi-cog", path: "/manage-website/pages/site" },
];

function SectionPage({ title, cards, highlights }) {

    return (
        <div className="flex flex-column h-full">
            <PageTitle title={title} />
            <TabHeader
                className="px-3 pt-3"
                title={title}
                highlights={highlights}
            />
            <Divider />
            <div className="flex-1 overflow-y-scroll p-3">
                <CardGrid cards={cards} />
            </div>
        </div>
    );
}

export function HomeSections() {
    return (
        <SectionPage
            title="Home page"
            cards={HOME_CARDS}
            highlights={["Sections follow the home page from top to bottom", "Course records and branch addresses are shared. They also have their own cards on the previous screen"]}
        />
    );
}

export function AboutSections() {
    return <SectionPage title="About Us page" cards={ABOUT_CARDS} highlights={["Open a block to edit the text saved for that page"]} />;
}

export function SiteSections() {
    return <SectionPage title="Site setup" cards={SITE_CARDS} highlights={["These details appear on every page", "Each page already has a built-in search title. Open Search titles only when you want to replace one", "Home can appear in the top menu and again under Footer quick links. Those are two separate links"]} />;
}

export function FacilitiesSections() {
    return <SectionPage title="Facilities page" cards={FACILITIES_CARDS} highlights={["Facility cards are also shown on the home page"]} />;
}

export function NotificationsSections() {
    return <SectionPage title="Notifications page" cards={NOTIFICATION_CARDS} highlights={["Start with the page text, then open Notices", "Open a notice to add extra photos and files", "Home shows the 3 newest notices. The home heading Latest Notifications stays as it is"]} />;
}

export function TestimonialsSections() {
    return <SectionPage title="Testimonials" cards={TESTIMONIAL_CARDS} highlights={["Start with the page text, then open Reviews", "Each review is one card in the slider on the home page", "This slider is not a separate public page"]} />;
}

export function GallerySections() {
    return <SectionPage title="Gallery page" cards={GALLERY_CARDS} highlights={["Start with the page text, then open Folders", "Each folder holds events. Each event has a Photos tab and a Videos tab", "The scrolling cards on the home page are edited under Home page"]} />;
}

export function BrochuresSections() {
    return <SectionPage title="e-Brochures page" cards={BROCHURE_CARDS} highlights={["Start with the page text, then open Course folders", "Each folder is one course. Inside it, add the brochure files", "The download cards on the home page are edited under Home page"]} />;
}

export function ContactSections() {
    return <SectionPage title="Contact Us page" cards={CONTACT_CARDS} highlights={["Start with the page text, then the branch cards", "Phone, WhatsApp, and email are shared with the rest of the site", "The headings Our Branches in Vadodara, Institute Contact, and Follow SAHAS stay as they are", "This page has no photo to upload. Each branch shows a Google map"]} />;
}

export function BranchesSections() {
    return <SectionPage title="Branches" cards={BRANCH_CARDS} highlights={["These cards appear on the home page, the Contact Us page, the About map, and the footer", "The home heading stays Our Branches. The contact heading stays Our Branches in Vadodara", "There is no separate public Branches page"]} />;
}

export function CoursesSections() {
    return <SectionPage title="Courses" cards={COURSE_CARDS} highlights={["This course list is used on the home page and the Courses page"]} />;
}

export function WebsiteCards() {
    return (
        <div className="flex flex-column h-full">
            <PageTitle title="Website Management" />
            <TabHeader className="px-3 pt-3" title="Website Management" highlights={["Pick a page. Courses and Branches are shared by the whole website"]} />
            <Divider />
            <div className="flex-1 overflow-y-scroll p-3">
                <CardGrid cards={WEBSITE_CARDS} />
            </div>
        </div>
    );
}
